import { Guid } from "../Utils/Guid";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface DtoBaseJson {
//	created_time: string;
//	modified_time: string;
//	guid: string;
//}

export class DtoBase implements ObjectSerializer {

	public GUID: Guid;
	public ModifiedTime: Date;
	public CreatedTime: Date;

	constructor() {
		this.GUID = null;
		this.ModifiedTime = null;
		this.CreatedTime = null;
	}

	public get HasGUID(): boolean {
		return (!!this.GUID && this.GUID != Guid.Empty);
	}

	public get HasModifiedTime(): boolean {
		return !!this.ModifiedTime;
	}

	public get HasCreatedTime(): boolean {
		return !!this.CreatedTime;
	}

//    public CopyDtoBaseJson(json: DtoBaseJson): void {
//        if (json.guid !== undefined)
//            this.GUID = Guid.FromString(json.guid);
//        if (json.modified_time !== undefined)
//            this.ModifiedTime = new Date(json.modified_time);
//        if (json.created_time !== undefined)
//			this.CreatedTime = new Date(json.created_time);
//	} 

	public Write(obj: any, context: any): void {

		// Called by subclass Write methods

		if (this.HasGUID)
			obj.guid = ValueEncoder.EncodeGuid(this.GUID);

		if (this.HasCreatedTime)
			obj.created_time = ValueEncoder.EncodeDateTime(this.CreatedTime);

		if (this.HasModifiedTime)
			obj.modified_time = ValueEncoder.EncodeDateTime(this.ModifiedTime);
	}

	public Read(obj: any, context: any): void {

		// Called by subclass Read methods

		if (obj.guid !== undefined)
			this.GUID = ValueEncoder.DecodeGuid(obj.guid);

		if (obj.created_time !== undefined)
			this.CreatedTime = ValueEncoder.DecodeDateTime(obj.created_time);

		if (obj.modified_time !== undefined)
			this.ModifiedTime = ValueEncoder.DecodeDateTime(obj.modified_time);
	}

}
